import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=62c91305"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=62c91305&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports